import React, { useRef } from 'react';
import classnames from 'classnames';
import SliderPager from '@/pages/intelligence/components/SliderPager';
import GeneralLegendContent from './components/GeneralLegendContent';
import useSliderPager from './hooks/useSliderPager';
import { analysisLegendOption } from './utils';
import { ECHARTSCOLOR as ECHARTS_COLORS } from '@/pages/intelligence/utils/echartsConst';
import type { IGeneralLegendProps } from './types';
import './index.scss';

const GeneralLegend: React.FC<IGeneralLegendProps> = (props) => {
  const { type, showDot, showIcon, formatter, options, value, onChange, onMouseEnter, onMouseOver, onMouseMove, onMouseLeave, className, style } = props;

  const legendsContainerNode = useRef<HTMLDivElement>(null);
  const legendsNodes = useRef<(HTMLLIElement | null)[]>([]);

  const { slideDistance, isShowPager, current, total, onCurrentChange } = useSliderPager({
    containerNode: legendsContainerNode,
    nodes: legendsNodes,
  });

  const handleLegendOptionChange = (namePayload: string, valuePayload: boolean) => {
    const valueTmp = {
      ...value,
      [namePayload]: valuePayload,
    };
    onChange(valueTmp);
  };

  return (
    <div
      style={style}
      className={classnames(className, {
        'dbi-general-legend': true,
        'has-pager': isShowPager,
      })}
    >
      <div ref={legendsContainerNode} className="dbi-general-legend_list-container">
        <ul
          style={{ transform: slideDistance === 0 ? 'translateX(0)' : `translateX(-${slideDistance}px)` }}
          className="dbi-general-legend_list-container_list"
        >
          {options?.map((option, index) => {
            const { icon: optionIcon, name: optionName, color: optionColor } = analysisLegendOption(option);
            const optionValue = !!value?.[optionName];
            const color = optionColor ?? option?.color ?? ECHARTS_COLORS[0];
            return (
              <li
                ref={(node) => (legendsNodes.current[index] = node)}
                className="dbi-general-legend_list-container_list_item"
                key={optionName}
              >
                <GeneralLegendContent
                  type={type}
                  showDot={showDot}
                  showIcon={showIcon}
                  name={optionName}
                  color={color}
                  icon={optionIcon}
                  formatter={formatter}
                  value={optionValue}
                  onChange={(payload) => {
                    handleLegendOptionChange(optionName, payload);
                  }}
                  onMouseEnter={onMouseEnter}
                  onMouseOver={onMouseOver}
                  onMouseMove={onMouseMove}
                  onMouseLeave={onMouseLeave}
                />
              </li>
            );
          })}
        </ul>
      </div>
      {isShowPager && (
        <div className="dbi-general-legend_pager-container">
          <SliderPager current={current} total={total} onChange={onCurrentChange} />
        </div>
      )}
    </div>
  );
};

export default GeneralLegend;
